import Masonry from "masonry-layout";

export default () => {
    const doms = document.querySelectorAll("[data-projects-grid]");
    if (doms.length) {
        window.addEventListener("load", () => {
        for (const dom of doms) {
            const msnry = new Masonry(dom, {
                itemSelector: ".project-tile",
                gutter: 0,
                horizontalOrder: true,
            });
        }
        });
    }
};
